import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiInstagram, FiMenu, FiX } from "react-icons/fi";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <motion.nav
      className={`${styles.nav} ${scrolled ? styles.scrolled : ""}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoAccent}>Travel</span>
          <span>with</span>
          <span className={styles.logoAccent}>Avara</span>
        </Link>

        <div className={styles.links}>
          <Link
            to="/"
            className={location.pathname === "/" ? styles.active : ""}
          >
            Home
          </Link>
          <Link
            to="/blog"
            className={location.pathname === "/blog" ? styles.active : ""}
          >
            Stories
          </Link>
          <Link
            to="/map"
            className={location.pathname === "/map" ? styles.active : ""}
          >
            Mapped Stories
          </Link>
          <Link
            to="/about"
            className={location.pathname === "/about" ? styles.active : ""}
          >
            About
          </Link>
          <a
            href="https://instagram.com/Travelwithavara"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.instagram}
          >
            <FiInstagram size={18} />
          </a>
        </div>

        <button
          className={styles.menuBtn}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className={styles.mobileMenu}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          >
            <Link to="/">Home</Link>
            <Link to="/blog">Stories</Link>
            <Link to="/map">Mapped Stories</Link>
            <Link to="/about">About</Link>
            <a
              href="https://instagram.com/Travelwithavara"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FiInstagram size={18} /> Instagram
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}
